var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background_color_web"},[_c('div',{staticClass:"container padding-top-20 padding-bottom-20"},[_c('LookupPower')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }